import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import { getDictionary, type Lang, type Dictionary } from "./index";

interface LangContextValue {
  lang: Lang;
  t: Dictionary;
  setLang: (lang: Lang) => void;
}

const LangContext = createContext<LangContextValue>({
  lang: "ko",
  t: getDictionary("ko"),
  setLang: () => {},
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = localStorage.getItem("steamdeal-lang") as Lang | null;
    return saved || "ko";
  });

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    localStorage.setItem("steamdeal-lang", l);
  }, []);

  const t = getDictionary(lang);

  return (
    <LangContext.Provider value={{ lang, t, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
